import { z } from 'zod';

import { PASSWORD_MIN_LENGTH } from '@constants';

export const passwordSchema = z
  .string()
  .min(PASSWORD_MIN_LENGTH, { message: `Password must be at least ${PASSWORD_MIN_LENGTH} characters` })
  .refine((val) => /[a-z]/.test(val), { message: 'Password should have at least one lowercase letter' })
  .refine((val) => /[A-Z]/.test(val), { message: 'Password should have at least one capital letter' })
  .refine((val) => /\d/.test(val), { message: 'Password should contain at least one digit' })
  .refine((val) => /[!@#$%^&*]/.test(val), { message: 'Password should contain at least one special character' });
